import React from 'react';
import { motion } from 'framer-motion';

const menuCategories = [
  {
    title: 'Main Courses',
    items: [
      { name: 'Butter Chicken', price: '21.99', description: 'Served with white rice, three pitas and an orange sauce' },
      { name: 'Poké Bowl', price: '18.99', description: 'Salmon, avocado, white rice, mango and tuna' },
      { name: 'Tuna Casserole', price: '19.99', description: 'Tuna, mushroom, bell pepper, basil and peas' },
      { name: 'Steak', price: '25.99', description: 'Sous vide steak with potato and a thick sauce' },
      { name: 'Tacos', price: '17.99', description: 'Ground beef, salsa, shredded lettuce and cheddar cheese' }
    ]
  },
  {
    title: 'Beverages',
    items: [
      { name: 'Kombucha', price: '8.99', description: 'Green tea and strawberry' },
      { name: 'Smoothie', price: '9.50', description: 'Blueberry, kiwi, banana and tangerine' },
      { name: 'Sparkling Water', price: '3.99', description: 'Sparkling water infused with fruit and veggies' },
      { name: 'Aloe Vera Juice', price: '5.99', description: 'Aloe gel blended with juice' },
    ]
  },
  {
    title: 'Desserts',
    items: [
      { name: 'Mango Coconut Chia Pudding', price: '13.99', description: 'Coconut milk, almond milk, chia seeds, shredded mango and coconut' },
      { name: 'Chocolate Brownie Date Balls', price: '13.99', description: 'Made with medjool dates, pumpkin, and cocoa powder' }
    ]
  }
];

const Menu = () => {
  return (
    <div className="bg-gray-900 py-12 min-h-screen">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <h1 className="text-4xl font-bold text-center mb-12 text-white">Our Menu</h1>
        </motion.div>

        <div className="space-y-12">
          {menuCategories.map((category, index) => (
            <motion.section
              key={category.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.2 }}
              className="bg-gray-800 rounded-lg shadow-lg p-6 border border-gray-700"
            >
              <h2 className="text-3xl font-semibold mb-6 text-cyan-100">
                {category.title}
              </h2>
              <div className="grid gap-6">
                {category.items.map((item) => (
                  <div key={item.name} className="border-b border-gray-700 pb-4 last:border-0">
                    <div className="flex justify-between items-start">
                      <div>
                        <h3 className="text-xl font-medium text-brand-400">{item.name}</h3>
                        <p className="text-gray-100 mt-1">{item.description}</p>
                      </div>
                      <span className="text-brand-400 text-xl font-semibold">${item.price}</span>
                    </div>
                  </div>
                ))}
              </div>
            </motion.section>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Menu;